@for (message of messages$ | async | slice:0:1; track message) {
  <div class="messagePopup" @displayHideTrigger>
    <div class="messagePopup__text is-{{ message.type }}">
      {{ message.text }}
    </div>
  </div>
}
